module.exports = __webpack_public_path__ + "static/media/text_analyze.435d50dc.png";